import dayjs from 'dayjs';

import type {DateTimeObj} from './types';

import {not} from '../conditionalUtils';
import {logger} from '../logger';
import {isDefined} from '../typecheck';
import {DEFAULT_DATETIME_OBJ, MINUS} from './utils';

export const ISOStringToDatetimeObj = (ISOString: string): DateTimeObj => {
  const isInvalidString =
    not(isDefined(ISOString)) || not(dayjs(ISOString).isValid());

  if (isInvalidString) {
    logger.error('Invalid ISOString.');

    return DEFAULT_DATETIME_OBJ;
  }

  try {
    const match = (ISOString.match(/\d+/g) || []).map(parseFloat);

    let [year, month, day, hour, minute, second, microsecond, tzH, tzM] = match;

    if (match.length === 8) {
      [year, month, day, hour, minute, second, tzH, tzM, microsecond] = match;
    }

    let utcoffset = 0;

    if (tzH || tzM) {
      if (tzM) {
        utcoffset += tzM;
      }

      utcoffset += tzH! * 60;

      if (ISOString.substr(-6, 1) === MINUS) {
        utcoffset *= -1;
      }
    }

    return {
      _type: 'datetime',
      day: day!,
      hour,
      microsecond: computeMicroseconds(microsecond),
      minute,
      month: month!,
      second,
      utcoffset,
      year: year!,
    };
  } catch (error) {
    return DEFAULT_DATETIME_OBJ;
  }
};

function computeMicroseconds(microseconds: number = 0) {
  const actualValue = microseconds * 1000;
  const wantedFormat = actualValue.toString().slice(0, 6);

  return parseInt(wantedFormat, 10);
}
